import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { AnalyticsService } from '@core/services/analytics.service';
import { select, Store } from '@ngrx/store';
import { toggleFilter } from '@results/store/results.actions';
// import { ToggleFilter } from '@results/store/results.actions';
import { IHotelsAppState } from '@store/index';
import { selectRouterQueryParamPriceBy } from '@store/router/router.selector';
import { FormsModule } from '@angular/forms';
import { MbFormField, MbFormFieldLabel, MbFormFieldSelect } from '@am/moebius';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'am-price-by',
  standalone: true,
  styleUrls: ['./price-by.component.scss'],
  templateUrl: './price-by.component.html',
  imports: [MbFormField, MbFormFieldLabel, MbFormFieldSelect, FormsModule, CommonModule],
})
export class PriceByComponent implements OnInit, OnChanges {
  @Input()
  public disabled: boolean;

  public priceBy: string;

  constructor(
    private store$: Store<IHotelsAppState>,
    private changeDetectorRef: ChangeDetectorRef,
    private analyticsService: AnalyticsService,
  ) {}

  public ngOnInit() {
    this.store$.pipe(select(selectRouterQueryParamPriceBy)).subscribe((priceBy) => {
      this.priceBy = priceBy ? priceBy : 'NIGHT';
    });
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.disabled) {
      this.changeDetectorRef.detectChanges();
    }
  }

  public changePriceBy() {
    this.trackPriceBy(this.priceBy);
    const newParams = {
      priceBy: this.priceBy,
    };
    this.store$.dispatch(toggleFilter({ payload: newParams }));
  }

  private trackPriceBy(priceBy) {
    this.analyticsService.trackEvent({
      action: 'Price By',
      label: priceBy || this.priceBy,
      section: 'Results',
    });
  }
}
